<template>
  <v-footer
    class="justify-center"
    color="grey lighten-2"
    height="auto"
    inset
  >
    <div class="text-center">
      <div class="social-buttons">
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="ma-1"
          icon
          :href="links[i]"
          target="_blank"
          rel="noopener noreferrer"
          @click="hitSocial(icon)"
        >
          <v-icon v-text="icon" />
        </v-btn>
      </div>
      <div class="my-3" />
      <div>Version 0.9.5</div>
      <div>&copy; 2014 &nbsp;<strong>Make Electronic Sound.</strong> All Rights Reserved.</div>
    </div>
  </v-footer>
</template>

<script>
  export default {
    name: 'CoreFooter',

    data: () => ({
      date: (new Date()).getFullYear(),
      icons: [
        'mdi-soundcloud',
        'mdi-facebook',
        'mdi-linkedin',
        'mdi-instagram',
        'mdi-youtube',
      ],
      links: [
        'https://soundcloud.com/make-electronic-sound',
        'https://www.facebook.com/profile.php?id=100085422463043',
        'https://www.linkedin.com/company/make-electronic-sound/',
        'https://www.instagram.com/makeelectronicsound/',
        'https://www.youtube.com/channel/UCVHNQ6gzGEO3isxMe8S0zQg',
      ],
    }),
    inject: ['eventBus'],
    mounted () {
      this.createFooterVisibilityObserver()
    },
    methods: {
      openCookieConsent () {
        this.$store.dispatch('showCookieConsent')
      },
      createFooterVisibilityObserver () {
        const options = {
          root: null,
          threshold: 0.1
        }
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.eventBus.$emit('footer-visible')
            }
          })
        }, options)
        observer.observe(this.$el)
      },
      hitSocial (icon) {
        // trackEvent({
        //   event: 'Footer Social Button Hit', // Specify the event name here
        //   event_category: 'Button Clicks',
        //   event_action: 'Click',
        //   event_label: icon
        // })
      }
    }
  }
</script>

<style scoped>
  .social-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 10px; /* Add some space between the social buttons and cookie button */
  }

  .cookie-settings-button {
    display: flex;
    justify-content: center; /* Center the button on the new line */
    width: 100%; /* Full width to push it to a new line */
  }

</style>
